import React from "react";
import { Helmet } from "react-helmet";
const ServicesHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        IT, Web Design, SEO & Digital Solutions | Digious Solutions
      </title>
      <meta
        name="description"
        content="Explore our expert services in web design, SEO, SMM, software, mobile app, and game development. Elevate your brand with creative digital strategies today."
      />
    </Helmet>
  );
};

export default ServicesHelmet;
